import { ClearFilters } from './typings'

export const clearAllFiltersActionCreator = (): ClearFilters => ({
  type: 'activityHistoryFilters/clear',
})
